import { render, staticRenderFns } from "./mybottom.vue?vue&type=template&id=6e0f9d78&scoped=true&"
import script from "./mybottom.vue?vue&type=script&lang=js&"
export * from "./mybottom.vue?vue&type=script&lang=js&"
import style0 from "./mybottom.vue?vue&type=style&index=0&id=6e0f9d78&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0f9d78",
  null
  
)

export default component.exports